import { getRandomString, getTimeInMilliSeconds } from "jwero-javascript-utils"

export const getRandomId = () => {
    return `${getTimeInMilliSeconds()}_${getRandomString(6)}`
}